// Routes
export const ROUTE_PATHS = {
  HOME: '/',
} as const;

// Slide data
export interface SlideData {
  id: number;
  type: 'cover' | 'stat' | 'equality' | 'diversity' | 'community' | 'protection' | 'neighborhood' | 'street' | 'award' | 'institutional' | 'presentation' | 'sponsors' | 'sponsors2';
}

export const SLIDES: SlideData[] = [
  { id: 0, type: 'cover' },
  { id: 1, type: 'stat' },
  { id: 2, type: 'equality' },
  { id: 3, type: 'diversity' },
  { id: 4, type: 'community' },
  { id: 5, type: 'protection' },
  { id: 6, type: 'neighborhood' },
  { id: 7, type: 'street' },
  { id: 8, type: 'award' },
  { id: 9, type: 'institutional' },
  { id: 10, type: 'presentation' },
  { id: 11, type: 'sponsors' },
  { id: 12, type: 'sponsors2' },
];

export const TOTAL_SLIDES = SLIDES.length;
